// extracted by mini-css-extract-plugin
export default {"gridOptions":"flowThroughK1Details_gridOptions__w4vjR","showCategorySubtotalsCheckbox":"flowThroughK1Details_showCategorySubtotalsCheckbox__VGkXJ"};